<div class="modal-header bg-light">
    <h4 class="modal-title">Lịch làm việc chi tiết</h4>
    <button type="button"
            class="close"
            aria-label="Close"
            (click)="activeModal.dismiss('Cross click'); closeTab()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
    <ngb-tabset [destroyOnHide]="false">
      <ngb-tab title="Chi tiết lịch">
        <ng-template ngbTabContent>
          <table class="table">
            <tbody>
              <tr>
                <td width="15%" class="h6">Nội dung:</td>
                <td colspan="3">{{ scheduleDetail.scheduleTitle }}</td>
              </tr>
              <tr>
                <td width="15%" class="h6">Chi tiết:</td>
                <td colspan="3">
                  <p [innerHTML]="scheduleDetail.scheduleContent"></p>
                </td>
              </tr>
              <tr>
                <td width="15%" class="h6">Ngày họp:</td>
                <td width="30%">
                  {{ scheduleDetail.scheduleDate | date: "dd/MM/yyyy" }}
                </td>
                <td width="15%" class="h6">Thời gian họp:</td>
                <td width="30%">{{ scheduleDetail.scheduleTime }}</td>
              </tr>
              <tr>
                <td width="15%" class="h6">Người chủ trì:</td>
                <td width="30%">{{ scheduleDetail.officerName }}</td>
                <td width="15%" class="h6">Đồng chủ trì:</td>
                <td width="30%">{{ scheduleDetail.otherHost }}</td>
              </tr>
              <tr>
                <td width="15%" class="h6">Địa điểm:</td>
                <td colspan="3">{{ scheduleDetail.scheduleLocation }}</td>
              </tr>
              <tr>
                <td width="15%" class="h6">Chuẩn bị:</td>
                <td width="30%">{{ scheduleDetail.departmentPrepare }}</td>
                <td width="15%" class="h6">Trạng thái:</td>
                <td width="30%">
                  <span [ngClass]="{
                      'text-primary':
                        scheduleDetail.scheduleStatus ===
                        scheduleStatus.Approve,
                      'text-success':
                        scheduleDetail.scheduleStatus ===
                        scheduleStatus.Release,
                      'text-danger':
                        scheduleDetail.scheduleStatus === scheduleStatus.Pause,
                      'text-info':
                        scheduleDetail.scheduleStatus === scheduleStatus.Changed
                    }">
                    {{
                      mapScheduleStatus(scheduleDetail.scheduleStatus)
                    }}
                  </span>
                </td>
              </tr>
              <tr>
                <td width="15%" class="h6">Thư mời họp:</td>
                <td colspan="3" class="text-danger">
                  <ng-template [ngIf]="scheduleDetail.isSendSMSInvite">
                    <p class="badge badge-primary">
                      <strong>Đã gửi thư mời</strong>
                    </p>
                  </ng-template>
                  <ng-template [ngIf]="!scheduleDetail.isSendSMSInvite">
                    <p class="badge badge-secondary">
                      <strong>Chưa gửi thư mời</strong>
                    </p>
                  </ng-template>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="h6">Thành phần:</td>
              </tr>
            </tbody>
          </table>
          <table class="table table-bordered">
            <thead>
              <tr>
                <td width="5%">STT</td>
                <td>Cơ quan nhận</td>
                <td>Người nhận</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="
                  let item of scheduleDetail.participantIsSelected;
                  let i = index
                ">
                <td>{{ i + 1 }}</td>
                <td>{{ item.departmentName }}</td>
                <td>{{ item.receiverName }}</td>
              </tr>
            </tbody>
          </table>
          <div class="h6">Thành phần tham dự khác:</div>
          <table class="table table-bordered">
            <thead>
              <tr>
                <td width="5%">STT</td>
                <td>Tên đơn vị/ Họ tên</td>
                <td>Email</td>
                <td>Số điện thoại</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="
                  let item of scheduleDetail.otherParticipants;
                  let i = index
                ">
                <td>{{ i + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.phoneNumber }}</td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </ngb-tab>
      <ngb-tab>
        <ng-template ngbTabTitle>Nhật ký</ng-template>
        <ng-template ngbTabContent>
          <h3 *ngIf="scheduleHistory.length == 0" class="bg-light">
            Chưa có nhật ký nào
          </h3>
          <table *ngIf="scheduleHistory.length > 0"
                 class="table table-bordered">
            <thead>
              <tr>
                <td width="5%">STT</td>
                <td>Lịch sử thay đổi</td>
                <td width="20%">Thời gian thay đổi</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of scheduleHistory; let i = index">
                <td>{{ i + 1 }}</td>
                <td>
                  <span [ngClass]="{
                      'text-primary': item.changeTo === 'Tạo mới',
                      'text-success': item.changeTo === 'Đã phát hành',
                      'text-danger': item.changeTo === 'Lịch bị hoãn',
                      'text-primary': item.changeTo === 'Đã duyệt',
                      'text-muted': item.changeTo === 'Đang soạn thảo'
                    }">
                    {{ item.changeTo }}
                  </span>
                </td>
                <td>{{ item.changeDate | date: "dd/MM/yyyy hh:mm a" }}</td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </ngb-tab>
      <!--Schedule files attachment-->
      <ngb-tab>
        <ng-template ngbTabTitle>Tài liệu họp</ng-template>
        <ng-template ngbTabContent>
          <h3 *ngIf="scheduleFilesAttachment.length == 0" class="bg-light">
            Chưa có tài liệu nào
          </h3>
          <table *ngIf="scheduleFilesAttachment.length > 0"
                 class="table table-bordered">
            <thead>
              <tr>
                <td width="5%">STT</td>
                <td style="width: 30%">Tên tài liệu</td>
                <td>Số ký hiệu</td>
                <td>Ngày phát hành</td>
                <td>Trích yếu</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <!-- <tr *ngFor="let item of scheduleFilesAttachment; let i = index">
                <td>{{ i + 1 }}</td>
                <td>
                  <a href="javascript:;" (click)="showFileContent(item.filePath)">{{item.fileName}}</a>                  
                </td>
                <td>{{ item.notationNumber }}</td>
                <td>{{ item.releaseDate | date: "dd/MM/yyyy hh:mm a" }}</td>
                <td>{{ item.quote }}</td>
              </tr> -->          
              <ng-container *ngFor="let objectType of attachmentMaster">
                <tr *ngIf="objectType.data.length > 0 && !isOnlyGeneralType">
                  <th colspan="5">
                    {{objectType.title}}
                  </th>
                </tr>
                <tr *ngFor="let item of objectType.data; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>   
                    <div (click)="showFileContent(item.filePath)" style="color: #3699FF">{{item.fileName}}</div>             
                    <!-- <a href="{{ item.filePath }}" target="_blank">{{ item.fileName }}</a>                   -->
                  </td>
                  <td>{{ item.notationNumber }}</td>
                  <td>{{ item.releaseDate | date: "dd/MM/yyyy hh:mm a" }}</td>
                  <td>{{ item.quote }}</td>
                  <td ngbTooltip="Tải xuống"><a href="{{getDownloadPath(item.filePath)}}"><i class="fas fa-file-download"></i></a></td>
                </tr>
              </ng-container>
              
            </tbody>
          </table>
          <!-- <div class="d-flex justify-content-center">
            <img src="{{src}}" style="width: 200px; height: 200px;">
          </div> -->
          <div class="d-flex justify-content-center">
            <!-- <div class="d-flex flex-column justify-content-center align-content-center">
              <a download="{{scheduleDetail.scheduleTitle + '.png'}}" class="btn btn-primary" href="{{'data:image/png;base64,' + qrString}}">Tải QR Code</a>              
            </div> -->
            
          </div>
          <div id="dom-qr-image">
            <div style="position: relative;">              
              <div style="position: absolute; top: 5%; width: 100%;">
                <div class="d-flex justify-content-center mb-5 p-5" style="text-align: center;">
                  <b
                    style="font-size: xx-large; text-transform: uppercase; line-height: 24px; font-size: 24px; font-family: 'Roboto Slab', serif;">{{scheduleTitle}}</b>
                </div>
              </div>
              <div style="position: absolute; bottom: 5%; width: 100%;">
                <div class="d-flex justify-content-center mb-5 p-5" style="text-align: center;">
                  <i style="color: black; font-size: x-large; line-height: 36px; font-family: 'Roboto Slab', serif;">Quý khách vui
                    lòng quét QR-Code tại đây</i>
                </div>
              </div>
              <img src="{{src}}" alt=""
                style="position: absolute; top: 50%; left: 50%; border: 2px solid white; width: 240px; transform: translate(-50%, -50%);">          
              <img src="../../../../../assets/images/qr-background.jpg" alt="">
            </div>
          </div>
          <div class="d-flex justify-content-center align-content-center">
            <button style="width: 240px;" (click)="downloadQRDOM()" class="btn btn-primary">Tải QR Code</button>
          </div>
        </ng-template>
      </ngb-tab>
    </ngb-tabset>
  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn btn-light"
            (click)="activeModal.close('Close click'); closeTab()">
      Đóng
    </button>
  </div>
